import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import {BrowserRouter as Router} from 'react-router-dom';
import RootReducer from './reducers/RootReducer';
import { Provider } from 'react-redux';

const store = createStore(
    RootReducer, 
    compose(applyMiddleware(thunk, promise)),
);

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
